/**
 * Javascript cookie functions.
 * @link https://www.guru99.com/cookies-in-javascript-ultimate-guide.html
 */

export default class EmCookie {
	constructor(cookieName) {
		this.cookieName = cookieName;
	}

	create(cookieValue, daysToExpire) {
		const date = new Date();
		date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
		document.cookie = `${this.cookieName}=${cookieValue};expires=${date.toGMTString()}`;
	}

	access() {
		const name = `${this.cookieName}=`;
		const allCookieArray = document.cookie.split(';');
		for (let i = 0; i < allCookieArray.length; i++) {
			const temp = allCookieArray[i].trim();
			if (temp.indexOf(name) === 0) {
				return temp.substring(name.length, temp.length);
			}
		}
		return false;
	}
}
